/* Packages */
import React from 'react';
import { render } from 'react-dom';

const vehicleDataManagerNodes = Array.from(document.querySelectorAll('[data-vehicle-data-manager]'));
if (vehicleDataManagerNodes.length) {
    import(/* webpackChunkName: "VehicleDataManager" */ './components/VehicleDataManager').then(({ default: VehicleDataManager }) => {
        vehicleDataManagerNodes.forEach((node) => render(<VehicleDataManager {...(JSON.parse(node.dataset.vehicleDataManager || '{}'))} />, node));
    });
}